import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import Countdown from "react-countdown";
import { useDispatch, useSelector } from "react-redux";
import { socketServer } from "../../assets/socketConnection";
import { createStructuredSelector } from "reselect";
import UserLogo from "../../assets/img/barnet_logo.svg";
import {
  UserWelcomeStyled,
  TextStyled,
  Circle,
  TextOptionsStyled,
  TimerStyled,
  TimerContainer,
  CallBtn,
  AlertNotifStyled,
} from "./inputSentCode.styles";
import { toEnglishNum, toPersianNum } from "../../assets/utils";
import {
  setLoginSentCode,
  fetchLoginPhoneConfirmAsync,
} from "../../redux/login/login.actions";
import { selectLoginSentCode } from "../../redux/login/login.selectors";
import {
  selectLoginConfirmMessage,
  selectLoginPhoneNumber,
} from "../../redux/login/login.selectors";
import { useHistory } from "react-router";
const InputSentCode = ({
  setLoginSentCode,
  loginSentCode,
  fetchLoginPhoneConfirmAsync,
}) => {
  const [show, setShow] = useState(false);
  const [showCounter, setShowCounter] = useState(true);
  const browserHistory = useHistory();
  const loginConfirmMessage = useSelector(selectLoginConfirmMessage);
  const loginPhoneNumber = useSelector(selectLoginPhoneNumber);
  const AutoLogin = () => {
    if (loginSentCode) {
      fetchLoginPhoneConfirmAsync(browserHistory);
      console.log("mamads");
    }
  };
  const handle_code_change = (e) => {
    setLoginSentCode(toEnglishNum(e.currentTarget.value));
    if (e.currentTarget.value.length === 6) {
      AutoLogin();
      e.currentTarget.blur();
      //   debugger;
      // e.currentTarget.classList.add("input--mr-n");
      // e.currentTarget.style.paddingRight = "40px";
      return;
      // e.currentTarget.style.marginRight = "-40px";
      // e.currentTarget.style.width = "calc(100% + 40px) !important";
    }
    // if (e.currentTarget.style.paddingRight === "40px") {
    //   debugger;
    //   e.currentTarget.style.paddingRi ght = "0";
    // }
    // alert("hi");
  };

  const handle_code_click = (e) => {
    if (e.currentTarget.value.length === 6) {
      e.currentTarget.value = "";
    }
  };
  const CallFromServer = () => {
    setShowCounter(false);
    fetch(`${socketServer}users/login_send_call`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ mobile: loginPhoneNumber }),
    })
      .then((response) => response.json())
      .then((result) => {
        console.log("barnet", result);
        setShow(true);
        // return (
        //   <AlertNotifStyled show={show}>
        //     <div className="alert-page__inner">
        //       <div>{result.detail}</div>
        //       <div className="d-flex align-items-center justify-content-center w-100 flex-column mt-3">
        //         <button
        //           className="alert-page__btn btn"
        //           onClick={() => setShow(false)}
        //         >
        //           باشه
        //         </button>
        //       </div>
        //     </div>
        //   </AlertNotifStyled>
        // );
      });
  };
  // useEffect(() => {
  //   fetch(`${socketServer}users/login_send_call`, {
  //     method: "POST",
  //     body: { mobile: loginPhoneNumber },
  //   })
  //     .then((response) => response.json())
  //     .then((result) => {
  //       console.log("barnet", result);
  //     });
  // }, []);

  const Texts = [
    "در صورت پایان زمان و عدم دریافت کد میتوانید از طریق روش‌های زیر برای دریافت کد اقدام نمایید.",
    "دریافت کد از طریق تماس صوتی با زدن گزینه دریافت تلفنی کد",
    "تماس با شماره ۰۲۱۹۱۰۰۴۷۳۳ از طریق شماره موبایل وارد شده و دریافت کد از پشتیبانی بارنت",
  ];
  const renderer2 = ({ days, hours, minutes, seconds, completed }) => {
    if (completed) {
      // Render a complete state
      // return <Completionist />;
      return (
        <TimerContainer>
          <CallBtn onClick={() => CallFromServer()}>دریافت تلفنی کد</CallBtn>
        </TimerContainer>
      );
    } else {
      // Render a countdown
      return (
        <TimerContainer>
          <TimerStyled>
            {seconds < 10 ? toPersianNum("0") : ""}
            {toPersianNum(seconds)}
          </TimerStyled>
          <TextStyled>:</TextStyled>
          <TimerStyled>
            {minutes === 0 ? toPersianNum("0") : ""}
            {toPersianNum("0")}
            {toPersianNum(minutes)}
          </TimerStyled>
        </TimerContainer>
      );
    }
  };
  var currentDate = new Date();
  var Deadline = new Date(currentDate.getTime() + 1 * 59000);
  return (
    <>
      <div className="d-flex">
        <div className="ml-2">
          <img src={UserLogo} alt="logo" />
        </div>
        <UserWelcomeStyled>
          <span style={{ fontSize: "16px", fontWeight: "999" }}>
            کاربر عزیز
          </span>
          <span style={{ fontSize: "14px", fontWeight: "999" }}>
            به بارنت خوش آمدید
          </span>
        </UserWelcomeStyled>
      </div>
      <div>{loginConfirmMessage.detail}</div>
      <div className="mt-5 pb-3">
        <div className="font-weight-bold font-size--3">
          کد ارسال شده را وارد کنید:
        </div>
        <div className="position-relative">
          <input
            onChange={(e) => handle_code_change(e)}
            onClick={(e) => handle_code_click(e)}
            className="input--custom position-relative  LoginPhoneFirstStep__input-code input--mr-n"
            style={{
              height: "48px",
              zIndex: 3,
              backgroundColor: "transparent",
            }}
            type="tel"
            name=""
            id=""
            maxLength="6"
            value={toPersianNum(loginSentCode)}
          />

          <div className="LoginPhoneFirstStep__input-code__boxes">
            <div className="LoginPhoneFirstStep__input-code__boxes__inner"></div>
            <div className="LoginPhoneFirstStep__input-code__boxes__inner"></div>
            <div className="LoginPhoneFirstStep__input-code__boxes__inner"></div>
            <div className="LoginPhoneFirstStep__input-code__boxes__inner"></div>
            <div className="LoginPhoneFirstStep__input-code__boxes__inner"></div>
            <div className="LoginPhoneFirstStep__input-code__boxes__inner"></div>
          </div>
        </div>
      </div>
      {showCounter && <Countdown date={Deadline} renderer={renderer2} />}
      {showCounter === false ? (
        <TimerContainer>
          <TextOptionsStyled style={{color:"#ffbf1d"}}>
            تا چند لحظه ی دیگر با شما تماس گرفته میشود{" "}
          </TextOptionsStyled>
        </TimerContainer>
      ) : (
        ""
      )}
      <TextStyled>{Texts[0]}</TextStyled>

      <TextOptionsStyled>
        <Circle />
        {Texts[1]}
      </TextOptionsStyled>
      <TextOptionsStyled>
        <Circle />
        {Texts[2]}
      </TextOptionsStyled>
    </>
  );
};

const mapStateToProps = createStructuredSelector({
  loginSentCode: selectLoginSentCode,
});

const mapDispatchToProps = (dispatch) => ({
  setLoginSentCode: (x) => dispatch(setLoginSentCode(x)),
  fetchLoginPhoneConfirmAsync: (x) => dispatch(fetchLoginPhoneConfirmAsync(x)),
});

export default connect(mapStateToProps, mapDispatchToProps)(InputSentCode);
